import {
  GET_LIST_CATEGORIES,
  SET_LIST_PRODUCTS,
  SET_LIST_BRANDS,
  SET_LIST_VENDORS,
  SET_LIST_PRICE_TEMPLATES,
  SET_LIST_MEMBER_GROUPS,
  SET_ADOPTION_MODE,
  SET_FILTER_OPTION,
  SET_COMPLIANCE_LIST,
  SET_LIST_PRODUCT_TAGS,
} from '../types/masterCatalog'

import { SET_BATCHES, SET_BATCH_QUANTITIES } from '../types/batch'

import {
  getCategories,
  getCategoriesByFilter,
  addMasterCategoryAPI,
  updateSingleMasterCategory,
  updateMasterCategory,
  updateOrphanCategoriesAPI,
  setChildCategory,
  getVendors,
  getBrands,
  getTemplatePrice,
  setMasterProduct,
  getCombineProducts,
  getCombineMasterProductsV2,
  setArchiveMasterProduct,
  updateMasterProduct,
  setChildProduct,
  updateChildProduct as updateChildProductAPI,
  updateChildProducts as updateChildProductsAPI,
  updateChildCategories as updateChildCategoriesAPI,
  removeChildProducts as removeChildProductsAPI,
  removeChildCategories as removeChildCategoriesAPI,
  updateSingleMasterProduct,
  unlinkProductFromParent,
  unlinkCategoryFromParent,
  setArchiveMasterCategory,
  getSMasterProducts,
  getChildCategories,
  getMemberGroups,
  updateComplexPricing,
  getMasterProduct as getMasterProductAPI,
  getMasterProductWithChilds as getMasterProductWithChildsAPI,
  getMasterCategoryAPI,
  addLocationToMasterProduct,
  getInventories,
  getBatches,
  getChildProduct as getChildProductAPI,
  getProductQuantityInfo,
  adoptOrphanCategoriesAPI,
  adoptOrphanProductsAPI,
  updateBulkUpdateChild,
  updateProductTagsAPI,
  getBlazeCategoriesAPI,
  searchAvailableMasterProductsAPI,
  bulkUpdateChildCategoriesAPI,
  getCombinedCategoriesByFilter,
  getMetrcCategoryListAPI,
  updateProductCategory,
  validateStoreCategoriesAPI,
  listProductTags,
} from '../api/masterCatalog'

import { addMessageCurry, commonActionAPIHit, commonActionAPIHitWithError } from '../utils/api'

export const setListCategories = (payload) => ({
  type: GET_LIST_CATEGORIES,
  payload,
})

export const setFilterOption = (payload) => ({
  type: SET_FILTER_OPTION,
  payload,
})

export const setListProducts = (payload) => ({
  type: SET_LIST_PRODUCTS,
  payload,
})

export const setComplianceCategoryList = (payload) => ({
  type: SET_COMPLIANCE_LIST,
  payload,
})

export const setListBrands = (payload) => ({
  type: SET_LIST_BRANDS,
  payload,
})

export const setListVendors = (payload) => ({
  type: SET_LIST_VENDORS,
  payload,
})

export const setListTemplatePrice = (payload) => ({
  type: SET_LIST_PRICE_TEMPLATES,
  payload,
})

export const setListProductTags = (payload) => ({
  type: SET_LIST_PRODUCT_TAGS,
  payload,
})

export const setListMemberGroups = (payload) => ({
  type: SET_LIST_MEMBER_GROUPS,
  payload,
})

export const setBatches = (payload) => ({
  type: SET_BATCHES,
  payload,
})

export const setBatchQuantities = (payload) => ({
  type: SET_BATCH_QUANTITIES,
  payload,
})

export const setAdoptionMode = (payload) => ({
  type: SET_ADOPTION_MODE,
  payload,
})

export const setAdoptionModeMasterProducts = (value) => {
  return (dispatch) => {
    dispatch(setAdoptionMode(value))
  }
}

export const getListCategories = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getCategories(), dispatch).then((res) => {
        dispatch(setListCategories((res && res.values) || []))
        resolve(res)
      })
    })
  }
}

export const getListCategoriesFilter = (skip, limit, term, filter) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(
        getCategoriesByFilter(skip, limit, term, filter, false),
        dispatch,
        '',
        '',
        false,
      ).then((res) => {
        dispatch(setListCategories((res && res.values) || []))
        resolve(res)
      })
    })
  }
}

export const getCombinedCategoryList = (skip, limit, term, filter, type) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(
        getCombinedCategoriesByFilter(skip, limit, term, filter, type, false),
        dispatch,
        '',
        '',
        false,
      ).then((res) => {
        dispatch(setListCategories((res && res.values) || []))
        resolve(res)
      })
    })
  }
}

export const getListChildCategories = (shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getChildCategories(shopId), dispatch).then((res) => {
        //dispatch(setListCategories(res));
        resolve(res)
      })
    })
  }
}

export const getChildProduct = (shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getChildProductAPI(shopId), dispatch).then((res) => {
        //dispatch(setListCategories(res));
        resolve(res)
      })
    })
  }
}

export const getListVendors = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getVendors(), dispatch).then((res) => {
        dispatch(setListVendors(res.values))
        resolve(res)
      })
    })
  }
}

export const validateStoreCategories = (shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(validateStoreCategoriesAPI(shopId), dispatch)
        .then((shop) => {
          resolve(shop)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getListBrands = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getBrands(), dispatch).then((res) => {
        dispatch(setListBrands(res.values))
        resolve(res)
      })
    })
  }
}

export const updateMasterProductList = (newList) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setListProducts(newList))
      resolve(newList)
    })
  }
}

export const getListPriceTemplates = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getTemplatePrice(), dispatch).then((res) => {
        dispatch(setListTemplatePrice(res.values))
        resolve(res)
      })
    })
  }
}

export const getListProductTags = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(listProductTags(), dispatch).then((res) => {
        dispatch(setListProductTags(res))
        resolve(res)
      })
    })
  }
}

export const getListMemberGroups = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMemberGroups(), dispatch).then((res) => {
        dispatch(setListMemberGroups(res.values))
        resolve(res)
      })
    })
  }
}

export const getListCombineProducts = (
  start,
  limit,
  term,
  filter,
  sortBy,
  sortByDirection,
  type,
  masterCategoryIds = [],
  brandIds = [],
  vendorIds = []
) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(
        getCombineMasterProductsV2(start, limit, true, term, filter, sortBy, sortByDirection, type,masterCategoryIds,brandIds,vendorIds),
        dispatch,
      ).then((res) => {
        dispatch(setListProducts(res.values))
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export const searchAvailableMasterProducts = (start, limit, term, sortBy, sortByDirection) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(
        searchAvailableMasterProductsAPI(start, limit, term, sortBy, sortByDirection),
        dispatch,
      ).then((res) => {
        dispatch(setListProducts(res.values))
        resolve(res)
      })
    })
  }
}

export const getSearchMasterProducts = (start, limit, term, filter, type) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(
        getSMasterProducts(start, limit, term, filter, true, type),
        dispatch,
        '',
        '',
        false,
      ).then((res) => {
        dispatch(setListProducts(res.values))
        resolve(res)
      })
    })
  }
}

export const getMasterProduct = (productId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMasterProductAPI(productId), dispatch).then((res) => {
        //dispatch(setProduct(res.values))
        resolve(res)
      })
    })
  }
}

export const getMasterProductWithChilds = (productId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMasterProductWithChildsAPI(productId), dispatch).then((res) => {
        resolve(res)
      })
    })
  }
}

export const getMasterCategory = (masterCategoryId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMasterCategoryAPI(masterCategoryId), dispatch).then((res) => {
        resolve(res)
      })
    })
  }
}

export const getListInventories = (shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const data = { shopId }
      addMessageCurry(getInventories(data), dispatch).then((res) => {
        //console.log("res",res);
        resolve(res.values)
      })
    })
  }
}

export const getListBatches = (masterId, shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const dataProd = { masterId }
      addMessageCurry(getBatches(dataProd, shopId), dispatch).then((res) => {
        dispatch(setBatches(res.values))
        //console.log("resBatch",res);
        resolve(res)
      })
    })
  }
}

export const getListProductQuantityInfo = (masterId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const dataProdQty = { masterId }
      addMessageCurry(getProductQuantityInfo(dataProdQty), dispatch).then((res) => {
        dispatch(setBatchQuantities(res))
        //console.log("resQuantity",res);
        resolve(res)
      })
    })
  }
}

export const adoptOrphanCategories = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(adoptOrphanCategoriesAPI(data), dispatch).then((res) => {
        resolve(res.values)
      })
    })
  }
}

export const adoptOrphanProducts = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(adoptOrphanProductsAPI(data), dispatch).then((res) => {
        resolve(res.values)
      })
    })
  }
}

export const getComplianceCategoryList = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getMetrcCategoryListAPI(), dispatch)
        .then((list) => {
          dispatch(setComplianceCategoryList((list && list.values) || []))
          resolve(list)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const updateChildProducts = (masterProducts, shopIds) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateChildProductsAPI(masterProducts, shopIds), dispatch).then((res) => {
        resolve(true)
      })
    })
  }
}

export const updateChildCategories = (masterCategories, shopIds) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateChildCategoriesAPI(masterCategories, shopIds), dispatch).then((res) => {
        resolve(true)
      })
    })
  }
}

export const removeChildProducts = (masterProducts, shopIds) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(removeChildProductsAPI(masterProducts, shopIds), dispatch).then((res) => {
        resolve(true)
      })
    })
  }
}

export const removeChildCategories = (masterCategory, shopIds) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(removeChildCategoriesAPI(masterCategory, shopIds), dispatch).then((res) => {
        resolve(true)
      })
    })
  }
}

export const bulkUpdateChildCategories = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(bulkUpdateChildCategoriesAPI(data), dispatch).then((res) => {
        resolve(true)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export const updateProductTags = (shopIds, productTags) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateProductTagsAPI(shopIds, productTags), dispatch).then((res) => {
        resolve(res)
      })
    })
  }
}

export const addMasterCategory = commonActionAPIHit(addMasterCategoryAPI)

export const updateSingleMasterCategories = commonActionAPIHitWithError(updateSingleMasterCategory)

export const updateMasterCategories = commonActionAPIHit(updateMasterCategory)

export const updateOrphanCategories = commonActionAPIHit(updateOrphanCategoriesAPI)

export const updateArchiveMasterCategory = commonActionAPIHit(setArchiveMasterCategory)

export const saveChildCategories = commonActionAPIHit(setChildCategory)

export const saveMasterProduct = commonActionAPIHit(setMasterProduct)

export const updateArchiveMasterProduct = commonActionAPIHit(setArchiveMasterProduct)

export const updateMasterProducts = commonActionAPIHit(updateMasterProduct)

export const saveChildProducts = commonActionAPIHit(setChildProduct)

export const updateChildProduct = commonActionAPIHit(updateChildProductAPI)

export const updateSingleMasterProducts = commonActionAPIHitWithError(
  updateSingleMasterProduct,
  '',
  '',
  false,
)

export const unlinkProductsFromParent = commonActionAPIHit(unlinkProductFromParent)

export const unlinkCategoriesFromParent = commonActionAPIHit(unlinkCategoryFromParent)

export const updateComplexPricingProduct = commonActionAPIHit(updateComplexPricing)

export const addLocationMasterProduct = commonActionAPIHit(addLocationToMasterProduct)

export const bulkUpdateChildProducts = commonActionAPIHitWithError(updateBulkUpdateChild, '', '', false)

export const getBlazeCategories = commonActionAPIHit(getBlazeCategoriesAPI)

export const updateChildCategory = commonActionAPIHit(updateProductCategory)

export const updateOrphanCategory = commonActionAPIHit(updateProductCategory)



// WEBPACK FOOTER //
// ./src/actions/masterCatalog.js